export { default as CampaignEmployeesModel } from './CampaignEmployeesModel';
export { default as CampaignsGateway } from './CampaignsGateway';
export { default as CampaignsService } from './CampaignsService';
export { default as CampaignsServiceProvider } from './CampaignsServiceProvider';



// WEBPACK FOOTER //
// ./src/api/campaigns/index.js